const ApiEndpoints = {
  file: {
    get: "/file-store/file-content",
  },
  nomenclature: {
    countries: "/countries",
    referenceData: {
      base: "/reference-data",
    },
    nationalUniversities: "/national-universities",
    contentManagement: "/content-management",
    profGroup: "/prof-group",
  },
  user: {
    loggedUser: "/nacid-user-details",
  },
  academicRecognition: {
    nacid: {
      filterRecords: "/acadrec-nacid-registers",
      arNacidRecord: "/acadrec-nacid-registers/{id}",
    },
    universities: {
      filterRecords: "/acadrec-university-registers",
      arUniversitiesRecord: "/acadrec-university-registers",
      autocompleteApplicants: "/acadrec-university-registers/autocomplete-applicants",
      autocompleteUniversities: "/acadrec-university-registers/autocomplete-universities",
      autocompleteDiplomaSpecialities: "/acadrec-university-registers/autocomplete-diploma-specialities",
      autocompleteRecognizedSpecialities: "/acadrec-university-registers/autocomplete-recognized-specialities",
      autocompleteEducationLevels: "/acadrec-university-registers/autocomplete-edu-levels",
      autocompleteRecords: "/acadrec-university-registers/autocomplete",
    },
  },
  professionalQualification: {
    filterRecords: "/regprof-registers",
    professionalQualification: "/regprof-registers/{id}",
  },
  secondary: {
    existsByAccessCode: "/secondary-recognition/exists/{accessCode}",
    findByAccessCode: "/secondary-recognition/by-access-code/{accessCode}",
    findByQrCodeUUID: "/secondary-recognition/by-qr-code/{accessCode}",
  },
  arUniEntryRequest: {
    saveARUniEntryRequest: "/ar-university-entry-request/save",
    saveAndPublishARUniEntryRequest: "/ar-university-entry-request/save-and-publish",
    filterRequests: "/ar-university-entry-request",
    getRequest: "/ar-university-entry-request",
    accept: "/admin/ar-university-entry-request/accept-request",
    reject: "/admin/ar-university-entry-request/reject-request",
    allowedEduLevels: "/ar-university-entry-request/allowed-edu-levels",
    allowedRecognitionStatuses: "/ar-university-entry-request/allowed-recognition-statuses",
  },
  certificate: {
    base: "/certificate",
  },
};

export { ApiEndpoints };
